import { type ThunkAction } from 'redux-thunk';
import { type ActionType } from 'typesafe-actions';

import { RequestStatus } from '../../../../models';
import * as api from '../api';
import type RootState from '../RootState';

import * as actions from './actions';

type Actions = ActionType<typeof actions>;
type ShortcutsThunkAction = ThunkAction<void, RootState, unknown, Actions>;

export const requestShortcuts =
  (gatewayApiUrl: string): ShortcutsThunkAction =>
  async (dispatch, getState) => {
    if (getState().shortcuts.defaultShortcutsStatus === RequestStatus.Pending) {
      return;
    }

    dispatch(actions.shortcutsRequested());

    try {
      const shortcuts = await api.readShortcuts(gatewayApiUrl);

      dispatch(actions.shortcutsReceived(shortcuts));
    } catch (e) {
      dispatch(actions.shortcutsNotReceived());
    }
  };
